export const WIN_FEATURES =
  "toolbar=yes,scrollbars=yes,resizable=yes,top=100,left=50,width=1200,height=500";
